<template>
  <ul class="footer__socials">
    <li
      v-for="icon in socialIcons"
      :key="icon.href"
      class="footer__social"
    >
      <a
        class="footer__social-link"
        rel="noopener noreferrer"
        target="_blank"
        :href="icon.href"
        :data-gtmid="icon['data-gtmid']"
      >
        <component :is="icon.svg"></component>
      </a>
    </li>
  </ul>
</template>

<script>
import SvgTelegram from '~/assets/icons/social/telegram.svg'
import SvgFb from '~/assets/icons/social/fb.svg'
import SvgVk from '~/assets/icons/social/vk.svg'
import SvgTwitter from '~/assets/icons/social/twitter.svg'
import SvgHabr from '~/assets/icons/social/habr.svg'
import SvgInstagram from '~/assets/icons/social/instagram.svg'
import SvgYoutube from '~/assets/icons/social/youtube.svg'

const socialIcons = [
  {
    href: 'https://t.me/SelectelNews',
    svg: SvgTelegram,
    'data-gtmid': 'gtm-selectel-telegram-click'
  },
  {
    href: 'https://www.facebook.com/selectel/',
    svg: SvgFb
  },
  {
    href: 'https://vk.com/selectel',
    svg: SvgVk
  },
  {
    href: 'https://twitter.com/selectel',
    svg: SvgTwitter
  },
  {
    href: 'https://habr.com/ru/company/selectel/',
    svg: SvgHabr
  },
  {
    href: 'https://www.instagram.com/selectel.ru/',
    svg: SvgInstagram
  },
  {
    href: 'https://www.youtube.com/channel/UCVU0Ml1l_Y90wmy5EjWTSng',
    svg: SvgYoutube
  }
]

export default {
  name: 'FooterSocials',
  components: {
    SvgTelegram,
    SvgFb,
    SvgVk,
    SvgTwitter,
    SvgHabr,
    SvgInstagram,
    SvgYoutube
  },
  data() {
    return {
      socialIcons
    }
  }
}
</script>

<style lang="scss">
.footer__socials {
  padding: 0;
  margin: 0 0 43px;
  width: 83%;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  list-style: none;

  @media (max-width: $breakpoint-xxl + 1) {
    width: 82%;
  }

  @media (max-width: $breakpoint-xl + 1) {
    width: 90%;
    margin-bottom: 30px;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 13px 0;
  }

  @media (max-width: 1150px) {
    width: 85%;
  }

  @media (max-width: $breakpoint-lg) {
    margin-top: 40px;
    margin-left: 10px;
    margin-bottom: 14px;
    grid-template-columns: repeat(7, 1fr);
    width: 40%;
  }

  @media (max-width: $breakpoint-md) {
    margin-top: 8px;
    width: 100%;
    grid-gap: 7%;
  }

  @media (max-width: 450px) {
    margin-left: 0;
    grid-gap: 5%;
  }

  svg {
    display: block;
    fill: #FFF;
    transition: fill 0.2s;
  }
}

.footer__social-link:hover {
  svg {
    fill: $secondary;
  }
}
</style>